module.exports = __webpack_public_path__ + "static/img/img-features-feature-6-parents_ko.3442048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-6-parents_ko.png
// module id = maeM
// module chunks = 18